/**
 * Reducer to handle bill splitting
 */

import { ActionTypes as types } from '../constants'
import serverProps from '../utils/serverProps'

function getInitialState(props) {
  const {
    recipientData: {
      partnerDisplayName = '',
      logoUrl = '',
      shouldAutoClose = false,
    } = {},
    counterParty = '',
    category = '',
  } = props

  const initialState = {
    requesterAmount: '',
    partnerDisplayName,
    logoUrl,
    shouldAutoClose,
    isRequesterAmountFrozen: false,
    includeRequester: false,
    frozenRecipients: 0,
    amountFrozen: 0,
    counterParty,
    category,
  }

  return initialState
}

export default (state = getInitialState(serverProps), action) => {
  switch (action.type) {
    case types.BILL_SPLITTING.CHANGE_REQUESTER_AMOUNT:
      return {
        ...state,
        requesterAmount: action.data.requesterAmount,
      }

    case types.BILL_SPLITTING.CHANGE_INCLUDE_REQUESTER:
      return {
        ...state,
        includeRequester: action.data.includeRequester,
      }

    case types.BILL_SPLITTING.UPDATE_FROZEN_INDICATORS:
      return {
        ...state,
        isRequesterAmountFrozen: action.data.isRequesterAmountFrozen,
        frozenRecipients: action.data.frozenRecipients,
        amountFrozen: action.data.amountFrozen,
      }

    case types.BILL_SPLITTING.RESTORE_SPLIT_STATE:
    case types.TRANSACTION.CANCELLED_TRANSACTION:
    case types.TRANSACTION.LEAVING_SUCCESS_PAGE:
      return getInitialState(serverProps)

    default:
      return state
  }
}
